import React from 'react';
import { connect } from 'react-redux';
import { is } from 'immutable';
import VisibilitySensor from 'react-visibility-sensor';

import { orderByStatus } from '~/actions/orders';
import Spinner from '~/components/Spinner';
import dynamicSort from '~/utils/dynamicSort';

import Order from './order';
import Styles from './order.scss';

class OrderView extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { loadMore: false };
  }
  componentDidMount() {
    // add check if is loaded
    if (this.props.tabData === false) {
      orderByStatus(
        this.props.dispatch,
        this.context.apiClient,
        this.props.name
      );
    }
  }
  shouldComponentUpdate(nextProps) {
    if (nextProps.orderBy !== this.props.orderBy) {
      return true;
    }
    if (is(nextProps.tabData, this.props.tabData)) {
      return false;
    }
    return true;
  }
  shouldLoadMore() {
    const loadedData = this.props.tabData && this.props.tabData.toJS();
    if (loadedData.count === loadedData.limit) {
      //  we loaded as many items as we got,
      // try to load more
      this.setState({ loadMore: true }, () => {
        orderByStatus(
          this.props.dispatch,
          this.context.apiClient,
          this.props.name,
          loadedData.from
        ).then(() => {
          this.setState({ loadMore: false });
        });
      });
    } else {
      this.setState({ loadMore: false });
    }
    this.setState({ loadMore: false });
    // console.log('Load more', isAtBottom);
  }
  render() {
    const { tabData } = this.props;
    const { loadMore } = this.state;
    console.log('render orderView', this.props.name);
    if (!tabData) {
      return (
        <div className={Styles.orderContent}>
          <Spinner />
        </div>
      );
    }
    const tabDataJs = tabData.toJS();
    tabDataJs.orders.sort(dynamicSort(this.props.orderBy));
    const orders = tabDataJs.orders.map(item => {
      return <Order item={item} key={`order_${item.orderId}`} />;
    });
    return (
      <div>
        {orders}
        {loadMore && <Spinner />}
        <VisibilitySensor
          onChange={isVisible => {
            this.shouldLoadMore(isVisible);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    tabData: state.getIn(['orders', 'tabData', ownProps.name], false)
  };
};

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(OrderView);



// WEBPACK FOOTER //
// ./app/pages/Orders/orderView.js